import {THEME_IMG, URL_FOR_RESOURCES} from "../app/AppConfig";
import t from "../components/I18N/TranslateHelpers";
import React from "react";
import {FavouriteProducts, ImageProduct, Product, ProductVariant} from "../features/Entity/Product";
import {PutItemToCartOfferRequest} from "../features/Entity/PutItemToCartRequest";
import {
  addItemToOfferCart,
  changeQuantityItemInOfferCart,
  removeItemFromOfferCart
} from "../features/Offer/OfferCartSlice";
import {LocalParams} from "./LocalParams";
import {
  addItemToCart,
  changeQuantityItemInCart,
  createCartAndAddItem,
  removeItemFromCart
} from "../features/Cart/CartSlice";
import {ProductsInCart} from "../features/Entity/Cart";
import {Filter} from "../features/Entity/Filter";
import { addItemInWishList } from "../features/User/UsersSlice";
import { GetUrlParams } from "./Utils";

export const allStepForStepsForm = (allSteps: any[], activeStep: number) => {
  return(
    allSteps.map((stepItem, index) => {
      return (
        <div className="step" key={stepItem.id}>
          <img src={THEME_IMG + stepItem.icon} width="50" height="50" alt=""/>
          <p className={activeStep > stepItem.step ? "active" : activeStep === stepItem.step ? "text-primary" : ""}>{stepItem.label}</p>
          <div className={activeStep > stepItem.step ? "bullet active" : activeStep === stepItem.step ? "bullet bg-primary-color" : "bullet"}>
            <span>{index+1}</span>
          </div>
          <div className={activeStep > stepItem.step ? "check fas fa-check active" : "check fas fa-check"}/>
        </div>
      )
    })
  )
}

export const buttonForWishlist = (isForAdd: boolean, dispatch: any, productId: any, setIsInWishlist: any, setProductIdRequest?: any ) => {
  return (
    <button
      className={isForAdd ? "btn btn-light add-whishlist float-end" : "btn btn-light active-whishlist float-end"}
      title={isForAdd ? t('add_to_favourites') : t('delete_from_favourites')}
      onClick={() => [addOrRemoveItemWishlist(dispatch, productId, setProductIdRequest), setIsInWishlist(isForAdd), setProductIdRequest(productId)]}>
      <i className="fa fa-heart"/>
    </button>
  )
}


export const buttonHtmlViewProduct = (linkProduct: string, locale: string, linkProductVariant: string) => {
  return(
    <a className="btn btn-primary px-2" href={ "/" + locale + t('url_detail_product') + "/" + linkProduct + "?variant=" + linkProductVariant}>
      <i className="me-1 fa fa-eye"/> { t('view_product')}
    </a>
  )
}

export const buttonsQuantity = (num: number, setNum: any) => {
  const incNum =()=>{
    setNum(Number(num)+1);
  }
  const decNum = () => {
    if(num>0) {
      setNum(num - 1);
    }
  }
  let handleChange = (e:any)=>{
    setNum(e.target.value);
  }
  return (
    <div className="input-group input-spinner">
      <button className="btn btn-icon btn-light" type="button" onClick={decNum}>
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#999" viewBox="0 0 24 24">
          <path d="M19 13H5v-2h14v2z"></path>
        </svg>
      </button>
      <input className="form-control text-center" placeholder="" value={num} onChange={handleChange}/>
      <button className="btn btn-icon btn-light" type="button" onClick={incNum}>
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#999"
             viewBox="0 0 24 24">
          <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"></path>
        </svg>
      </button>
    </div>
  )
}

export const getFirstImageProduct = (product: Product, isDetailProduct: boolean) => {
  let firstImageProduct:string = ""
  product && product.images && product.images.filter((a) => a.type === "Image").map((imageItem: ImageProduct) => {
    firstImageProduct = isDetailProduct ? URL_FOR_RESOURCES + imageItem.path : URL_FOR_RESOURCES + "/media/image/" + imageItem.path
  })
  if(firstImageProduct === null || !firstImageProduct.length){
    firstImageProduct = THEME_IMG + "/images/esm-no-product-image.png"
  }
  return firstImageProduct
}

export const getFirstImageVariant = (variant: { code: string; product: { imageUrl: string | null; name: string; slug: string; id: number; } }) => {
  if (variant && variant.product && variant.product.imageUrl) {
    return URL_FOR_RESOURCES + "/media/image/" + variant.product.imageUrl;
  }
  return THEME_IMG + "/images/esm-no-product-image.png";
};



export const addItemToCartOrOfferCart = (
  variantCode: any,
  quantity: any,
  locale: any,
  dispatch: any,
  isAddInCart: boolean,
  setShowToaster: any,
  setIsToasterForCart: any,
  AddSuccess: boolean,
  userEmail: string | null,
  onSuccess?: () => void
) => {
  let putItemToCartDto: PutItemToCartOfferRequest = { variantCode, quantity, locale };
  const tokenCart = LocalParams.getItem('tokenCart') as string;

  if (isAddInCart) {
    if (!tokenCart) {
      dispatch(createCartAndAddItem(locale, putItemToCartDto, userEmail))
        .then(() => {
          setTimeout(() => {
            setShowToaster(true);
            setIsToasterForCart(true);
            if (onSuccess) {
              onSuccess();
            }
          }, 850);
        });
    } else {
      dispatch(addItemToCart(putItemToCartDto, tokenCart))
        .then(() => {
          setTimeout(() => {
            setShowToaster(true);
            setIsToasterForCart(true);
            if (onSuccess) {
              onSuccess();
            }
          }, 850);
        })
    }
  } else {
    dispatch(addItemToOfferCart(putItemToCartDto))
      .then(() => {
        if (onSuccess) {
          onSuccess();
        }
      })
  }
}

export const removeItemFromCartOffer = (variantCode: any, tokenValue: string, dispatch: any ) => {
  let putItemToCartDto: PutItemToCartOfferRequest = {variantCode: variantCode, tokenValue: tokenValue };
  dispatch(removeItemFromOfferCart(putItemToCartDto));
};

export const removeItemFromCartButton = (dispatch: any, itemId: number) => {
  const tokenCart = LocalParams.getItem('tokenCart') as string
  dispatch(removeItemFromCart(tokenCart, itemId));
};

export const changeQuantityItem = (newQuantity: number, variantCode: string, tokenValue: string, dispatch: any) => {
  dispatch(changeQuantityItemInOfferCart(variantCode, newQuantity, tokenValue));
};
export const changeQuantityIteminCart = (newQuantity: number, itemOrderId: number, tokenValue: string, dispatch: any) => {
  dispatch(changeQuantityItemInCart(tokenValue, itemOrderId, newQuantity));
};

export const checkIfItemInCartOffer = (nbItemInCartOffer: any, toggle: any) => {
  if(nbItemInCartOffer === 0){
    toggle()
  }
}

export const buttonOfferRequest = (
  variantCode: string,
  quantity: number,
  locale: string,
  dispatch: any,
  nbItemInCartOffer: number,
  toggle: any,
  setShowToaster: any,
  cartOfferAddSuccess: boolean,
  userEmail: string | null
) => {
  return (
    <>
      <button
        className="btn btn-primary w-100"
        onClick={() => {
          addItemToCartOrOfferCart(
            variantCode,
            quantity,
            locale,
            dispatch,
            false,
            undefined,
            undefined,
            cartOfferAddSuccess,
            userEmail,
            () => {
              toggle();
            }
          );
        }}
        disabled={quantity === 0}
      >
        <i className="fas fa-edit"></i> {t("request_offer")}
      </button>
      {quantity === 0 ? (
        <i
          className="fa-solid fa-info info-request-offer"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title="Tooltip on top"
        ></i>
      ) : null}
    </>
  );
};


export const buttonHtmlAddItemToCart = (isForAdd: boolean, variantCode: string, quantity: number, locale: string, dispatch: any, setShowToaster: any, setIsToasterForCart: any, cartAddSuccess: boolean, userEmail: string | null, orderItemId?: number) => {
  return (
    <button className={isForAdd ? "btn btn-primary" : "btn btn-outline-primary width100"} disabled={ isForAdd && quantity === 0}
            onClick={() => isForAdd ?
              (addItemToCartOrOfferCart(variantCode, quantity, locale, dispatch, true, setShowToaster, setIsToasterForCart, cartAddSuccess, userEmail))
              :
              orderItemId ? removeItemFromCartButton(dispatch, orderItemId) : undefined
            }>
      <i className="me-1 fa fa-shopping-basket"/> { isForAdd ? t('add_to_cart') : t('delete_from_cart')}
    </button>
  )
}

export const saveNewQuantityInCartOffer = (newQuantity: number, variantCode: string, tokenValue: string, dispatch: any) => {
  return (
    <button className="btn btn-light float-end" title="Sauvegarder la quantité" onClick={() => changeQuantityItem(newQuantity, variantCode, tokenValue, dispatch)}>
      <i className="fas fa-save"></i>
    </button>
  )
}

export const saveNewQuantityInCart = (newQuantity: number, itemOrderId: number, tokenValue: string, dispatch: any) => {
  return (
    <button className="btn btn-light float-end" title="Sauvegarder la quantité" onClick={() => changeQuantityIteminCart(newQuantity, itemOrderId, tokenValue, dispatch)}>
      <i className="fas fa-save"></i>
    </button>
  )
}

export const getVariantOfProduct = (productItem: any) => {
  if(!productItem.options)
    return <></>;
  return (
    <React.Fragment>
      {
        Object.keys(productItem.options).map(optionKey => (
          <span key={optionKey}><strong className="h6 price">{t(optionKey)} : </strong>{productItem.options[optionKey]}</span>
        ))
      }
    </React.Fragment>
  );
}

export const addOrRemoveItemWishlist = (dispatch: any, productId: string, setProductIdRequest?: any) => {
  dispatch(addItemInWishList(productId, setProductIdRequest))
}

export const productExistsInWishlist = (
  id: number,
  favouriteProductIds?: FavouriteProducts[] | null
): boolean => {
  if (!Array.isArray(favouriteProductIds)) return false;
  return favouriteProductIds.some(el => el.id === id);
};


export const variantExistsInCart = (variantCode: string, itemsInCart: ProductsInCart[]) => {
  return itemsInCart.some(el => el.variantCode === variantCode);
}

export const orderItemFromCart = (variantCode: string, itemsInCart: ProductsInCart[]) => {
  return itemsInCart.find(el => el.variantCode === variantCode) ?? null;
}

export const applyFiltersButton = (
  history: any,
  buttonInSidebar: boolean,
  pendingFilters: { index: string; values: string[] }[],
  setFiltersSelected: React.Dispatch<React.SetStateAction<any[]>>,
  newViewProduct: string,
  isEndOfStock: boolean,
  openFiltersOnMobile?: boolean,
  setOpenFiltersOnMobile?: any,
) => {
  const handleApplyFilters = () => {
    const cleanedFilters = pendingFilters.filter(filter => filter.values.length > 0);

    setFiltersSelected(cleanedFilters);

    const newUrl = buildUrlFromFilters(cleanedFilters, newViewProduct, isEndOfStock);
    history(newUrl);

    if (openFiltersOnMobile && setOpenFiltersOnMobile) {
      setOpenFiltersOnMobile(false);
    }
  };

  return (
    <button className={buttonInSidebar ? "btn btn-dark width100 mb-3" : "btn btn-sm btn-dark mr-5"} onClick={handleApplyFilters}>
      <i className="fa fa-check" /> {t("apply_filters")}
    </button>
  );
};


export const allFiltersButton = (openFiltersOnMobile: boolean, setOpenFiltersOnMobile: any) => {
  return(
    <button className="btn btn-dark width100 mb-3" onClick={() => setOpenFiltersOnMobile(!openFiltersOnMobile)}>
      <i className="fa-solid fa-filter"></i> {t('all_filters')}
    </button>
  )
}

export const applyFilters = (
  cleanedFilters: {index: string, values: string[]}[],
  setFiltersSelected: (filters: {index: string, values: string[]}[]) => void
) => {
  setFiltersSelected(cleanedFilters);
};


export const buttonDeleteFilters = (resetFilters:any) => {
  return(
    <button className="btn btn-sm btn-light btn-delete-filters" onClick={() => [resetFilters()]} >
      <i className="fa fa-undo"/> {t('delete_filters')}
    </button>
  )
}

export const handleCheckedFilters = (
  taxonItem: Filter,
  taxonomiesSelected: string[],
  setTaxonomiesSelected: React.Dispatch<React.SetStateAction<string[]>>,
  setGroupCode: React.Dispatch<React.SetStateAction<string>>,
  forcedGroupCode?: string
) => {
  setTaxonomiesSelected(prev => {
    const exists = prev.includes(taxonItem.code);
    return exists ? prev.filter(code => code !== taxonItem.code) : [...prev, taxonItem.code];
  });

  if (forcedGroupCode) {
    setGroupCode(forcedGroupCode);
    return;
  }

  if (taxonItem.groupCode) {
    setGroupCode(taxonItem.groupCode);
  }
};



export const hasSubTaxons = (parentTaxons: Filter, filters: any) => {
  let subTaxons: Filter[]= []
  filters && filters.filter((a:any) => a.parentCode === parentTaxons.code).map((item:any) => {
    subTaxons.push(item);
  })
  return subTaxons
}

export const countSelectedSubTaxon = (
  taxon: Filter,
  arraySubTaxonsCounter: { parentCode: string; taxonsCodes: string[]; count: number }[],
  setArraySubTaxonsCounter: React.Dispatch<React.SetStateAction<{ parentCode: string; taxonsCodes: string[]; count: number  }[]>>
) => {
  // Vérifie si le parentCode
  const existingIndex = arraySubTaxonsCounter.findIndex(item => item.parentCode === taxon.parentCode);
  const updatedArray = [...arraySubTaxonsCounter];

  if (existingIndex !== -1) {
    // Si le parentCode existe déjà, on update ses sous-taxons
    const existingTaxons = updatedArray[existingIndex];
    if (!existingTaxons.taxonsCodes.includes(taxon.code)) {
      existingTaxons.taxonsCodes.push(taxon.code);
    } else {
      // Si le taxonCode existe déjà, le supprime
      existingTaxons.taxonsCodes = existingTaxons.taxonsCodes.filter(code => code !== taxon.code);
      //s'il n'y a plus de taxonsCodes, alors on supprime l'entrée
      if(existingTaxons.taxonsCodes.length === 0){
        updatedArray.splice(existingIndex, 1);
      }
    }

    // Calcul le nombre de taxonsCodes pour ce parentCode
    const totalCount = existingTaxons.taxonsCodes.length;
    updatedArray[existingIndex] = {
      ...existingTaxons,
      count: totalCount
    };
  } else {
    // Si le parentCode n'existe pas, on ajoute
    if(taxon.parentCode != null){
      updatedArray.push({
        parentCode: taxon.parentCode,
        taxonsCodes: [taxon.code],
        count: 1
      });
    }
  }
  setArraySubTaxonsCounter(updatedArray);
};



export const pushItemsInSelectedFilters = (
  taxonItem: any,
  filtersSelected: any,
  setFiltersSelected: any | undefined,
  history: any,
  isEndOfStock: boolean
) => {
  let updatedFilters = [...filtersSelected];

  const existingFilter = updatedFilters.find(filter => filter.index === taxonItem.groupCode);

  if (existingFilter) {
    if (existingFilter.values.includes(taxonItem.code)) {
      existingFilter.values = existingFilter.values.filter((value: any) => value !== taxonItem.code);
    } else {
      existingFilter.values.push(taxonItem.code);
    }
  } else {
    updatedFilters.push({ index: taxonItem.groupCode, values: [taxonItem.code] });
  }

  updatedFilters = updatedFilters.filter(filter => filter.values.length > 0);

  if (setFiltersSelected) {
    setFiltersSelected([...updatedFilters]);
  }

  const currentParams = GetUrlParams();
  const currentView = currentParams["view"] ?? "thumb";
  const newUrl = buildUrlFromFilters(updatedFilters, currentView, isEndOfStock);
  history(newUrl);
};



export const removeItemFromAnArray = (array: any, item: any) => {
  let index = array.indexOf(item)
  if (index !== -1) {
    array.splice(index, 1);
  }
}

export const checkIfExist = (filtersSelected: any, subTaxonItem: any, setExistInActiveFilters: any) => {
  const isExist = filtersSelected.some((el: any) => el.values.includes(subTaxonItem.code));
  setExistInActiveFilters(isExist);
}


export const buildUrlFromFilters = (
  filters: { index: string; values: string[] }[],
  view: string,
  isEndOfStock: boolean
): string => {
  const params = new URLSearchParams();

  filters.forEach(filter => {
    if (filter.values.length > 0) {
      params.set(filter.index, filter.values.join(";"));
    }
  });

  if (isEndOfStock) params.set("isEndOfStock", "true");

  params.set("view", view);

  return `?${params.toString()}`;
};





